<div class="row header-upsell-items" *ngIf="upSellItems.length > 0">
    <div class="col-12">
        <h5 class="mt-3 ml-2 font-weight-bold">We also Recommended</h5>
    </div>
    <div class="col-12">
        <div class="menu2-container">
            <div class="col-6 upsell-box" *ngFor="let item of upSellItems;let i=index;">
                <div class="product-details">
                    <div (click)="addItemToCart(item)"
                        class="pl-2 card-title font-size-11 font-weight-bold pt-2 cursor pb-0 mb-0">
                        <!-- {{item.item_name}} -->
                        {{item.item_name}}

                    </div>
                </div>
                <div class="control">
                    <span class="price font-size-11 font-weight-bold"> {{item.item_price.toFixed(2)}}</span>
                </div>
                <div class="product-image">
                    <!-- <img src="http://localhost:4200/assets/images/Itemdefault.jpeg" alt=""> -->
                    <img *ngIf="item.item_image.length > 0" [defaultImage]="defaultImage" [lazyLoad]="item.item_image"
                        alt="image" style="object-fit: cover;">
                    <img *ngIf="!item.item_image.length" [defaultImage]="defaultImage" [lazyLoad]="defaultImage"
                        alt="location image">
                </div>
            </div>

        </div>


    </div>
</div>
<app-drawer [(visible)]="drawerVisible" (visibleChange)="onDrawerVisibleChange($event)">
    <ng-container *ngIf="drawerVisible && item_pkid">
        <app-ecom-item-details2 [item]="item" [onClose]="onClose" [item_pkid]="item_pkid" [iscvsd_pkid]="iscvsd_pkid"
            [category_pkid]="category_pkid" [upSellId]="upSellId"></app-ecom-item-details2>
    </ng-container>
</app-drawer>